import React from "react"

import {
  ADD_TEAM_MEMBERS_OVERLAY,
  CONFIRMATION_OVERLAY,
  CONTENT_OVERLAY,
  COPY_FLOOR_OVERLAY,
  COPY_PROJECT_CHILDREN_OVERLAY,
  COPY_ROOM_OVERLAY,
  DELETE_ADDON_OVERLAY,
  DELETE_ATTACHMENT_OVERLAY,
  DELETE_FAVORITES_OVERLAY,
  DELETE_FLOOR_OVERLAY,
  DELETE_PRODUCT_POSITIONS_OVERLAY,
  DELETE_PROJECT_CHILDREN_OVERLAY,
  DELETE_PROJECT_OVERLAY,
  DELETE_ROOM_OVERLAY,
  DEMAND_REQUEST_OVERLAY,
  DUPLICATE_PROJECT_OVERLAY,
  EDIT_FLOOR_OVERLAY,
  EDIT_PRODUCT_POSITION_OVERLAY,
  EDIT_PROJECT_OVERLAY,
  EDIT_ROOM_OVERLAY,
  FAVORITE_ACTIONS_OVERLAY,
  FEEDBACK_ACTIONS_OVERLAY,
  FEEDBACK_OVERLAY,
  FLOOR_ACTIONS_OVERLAY,
  GLOBAL_SEARCH_OVERLAY,
  IMAGE_OVERLAY,
  INSTALLATION_REFERENCE_SELECTION_OVERLAY,
  LOGIN_OVERLAY,
  LOGOUT_OVERLAY,
  MANAGE_PROJECT_TEAM_OVERLAY,
  MUSTERHEFT_EXPORT_OVERLAY,
  NEW_FLOOR_OVERLAY,
  NEW_PRODUCT_POSITION_OVERLAY,
  NEW_PROJECT_OVERLAY,
  NEW_ROOM_OVERLAY,
  Overlay,
  PORTAL_NEWS_OVERLAY,
  PORTFOLIO_PRODUCT_SELECT_OVERLAY,
  PRODUCT_CONFIGURATION_OVERLAY,
  PRODUCT_CONFIGURATOR_MODE_SELECT_OVERLAY,
  PRODUCT_IMAGE_OVERLAY,
  PRODUCT_POSITION_ACTIONS_OVERLAY,
  PROFILE_DELETE_CODE_OVERLAY,
  PROFILE_DELETE_REQUEST_CODE_OVERLAY,
  PROJECT_ACTIONS_OVERLAY,
  PROJECT_ATTACHMENTS_OVERLAY,
  PROJECT_GAEB_OVERLAY,
  PROJECT_HISTORY_OVERLAY,
  PROJECT_PDF_OVERLAY,
  PROJECT_TEAM_INVITATION_LIST_OVERLAY,
  REPLACE_ATTACHMENT_OVERLAY,
  ROOM_ACTIONS_OVERLAY,
  SELECT_PRODUCT_CONFIGURATION_PRESET_OVERLAY,
  SHARED_PROJECT_ACTIONS_OVERLAY,
  SHARE_OVERLAY,
  TEAM_LEAVE_OVERLAY
} from "shared/context/overlay/types"
import { DefaultConfirmationOverlay } from "shared/ui/confirmation-overlay/DefaultConfirmationOverlay"
import { ImageOverlay } from "shared/ui/image-overlay/ImageOverlay"

import { ContentOverlay } from "widgets/content-overlay/ContentOverlay"
import { CreateProjectTeamMembersOverlayConnector } from "widgets/create-project-team-members-overlay/CreateProjectTeamMembersOverlayConnector"
import { DemandRequestOverlayConnector } from "widgets/demand-request-overlay/DemandRequestOverlayConnector"
import { DeleteFavoritesOverlayConnector } from "widgets/favorites/delete-favorites-overlay/DeleteFavoritesOverlayConnector"
import { FavoriteActionsOverlayConnector } from "widgets/favorites/favorite-actions-overlay/FavoriteActionsOverlayConnector"
import { FeedbackActionsOverlayConnector } from "widgets/feedback-actions-overlay/FeedbackActionsOverlayConnector"
import { FeedbackOverlayConnector } from "widgets/feedback-overlay/FeedbackOverlayConnector"
import { CopyFloorOverlay } from "widgets/floor/copy-floor-overlay/CopyFloorOverlay"
import { DeleteFloorOverlayConnector } from "widgets/floor/delete-floor-overlay/DeleteFloorOverlayConnector"
import { EditFloorOverlayConnector } from "widgets/floor/edit-floor-overlay/EditFloorOverlayConnector"
import { FloorActionsOverlay } from "widgets/floor/floor-actions-overlay/FloorActionsOverlay"
import { NewFloorOverlayConnector } from "widgets/floor/new-floor-overlay/NewFloorOverlayConnector"
import { GlobalSearchOverlayConnector } from "widgets/global-search-overlay/GlobalSearchOverlayConnector"
import { InstallationReferenceSelectionOverlayConnector } from "widgets/installation-reference-selection/installation-reference-selection-overlay/InstallationReferenceSelectionOverlayConnector"
import { LoginOverlayConnector } from "widgets/login-overlay/LoginOverlayConnector"
import { LogoutOverlay } from "widgets/logout-overlay/LogoutOverlay"
import { ManageProjectTeamOverlayConnector } from "widgets/manage-project-team-overlay/ManageProjectTeamOverlayConnector"
import { PortalNewsOverlayConnector } from "widgets/portal-news-list/portal-news-overlay/PortalNewsOverlayConnector"
import { DeleteAddonOverlay } from "widgets/product-configuration/delete-addon-overlay/DeleteAddonOverlay"
import { PortfolioProductSelectOverlay } from "widgets/product-configuration/portfolio-product-select-overlay/PortfolioProductSelectOverlay"
import { ProductConfigurationOverlayConnector } from "widgets/product-configuration/product-configuration-overlay/ProductConfigurationOverlayConnector"
import { ProductConfiguratorModeSelectOverlayConnector } from "widgets/product-configuration/product-configurator-mode-select-overlay/ProductConfiguratorModeSelectOverlayConnector"
import { SelectProductBaseVariantOverlay } from "widgets/product-configuration/select-product-base-variant-overlay/SelectProductBaseVariantOverlay"
import { ProductImageOverlay } from "widgets/product-image-overlay/ProductImageOverlay"
import { DeleteProductPositionsOverlayConnector } from "widgets/product-position/delete-product-positions-overlay/DeleteProductPositionsOverlayConnector"
import { EditProductPositionOverlay } from "widgets/product-position/edit-product-position-overlay/EditProductPositionOverlay"
import { NewProductPositionOverlayConnector } from "widgets/product-position/new-product-position-overlay/NewProductPositionOverlayConnector"
import { ProductPositionActionsOverlay } from "widgets/product-position/product-position-actions-overlay/ProductPositionActionsOverlay"
import { ProfileDeleteOverlayConnector } from "widgets/profile-delete-overlay/ProfileDeleteOverlayConnector"
import { ProfileDeleteSubmitCodeOverlayConnector } from "widgets/profile-delete-submit-code-overlay/ProfileDeleteCodeOverlayConnector"
import { ProjectHistoryOverlayConnector } from "widgets/project-history/project-history-overlay/ProjectHistoryOverlayConnector"
import { ProjectTeamInvitationListOverlayConnector } from "widgets/project-team-invitation-list-overlay/ProjectTeamInvitationListOverlayConnector"
import { DeleteAttachmentOverlayConnector } from "widgets/project/delete-attachment-overlay/DeleteAttachmentOverlayConnector"
import { DeleteProjectChildrenOverlay } from "widgets/project/delete-project-children-overlay/DeleteProjectChildrenOverlay"
import { DeleteProjectOverlay } from "widgets/project/delete-project-overlay/DeleteProjectOverlay"
import { DuplicateProjectOverlay } from "widgets/project/duplicate-project-overlay/DuplicateProjectOverlay"
import { EditProjectOverlayConnector } from "widgets/project/edit-project-overlay/EditProjectOverlayConnector"
import { CopyProjectChildrenOverlayConnector } from "widgets/project/move-project-child-overlay/CopyProjectChildrenOverlayConnector"
import { MusterheftExportOverlayConnector } from "widgets/project/musterheft-export-overlay/MusterheftExportOverlayConnector"
import { NewProjectOverlayConnector } from "widgets/project/new-project-overlay/NewProjectOverlayConnector"
import { ProjectActionsOverlayConnector } from "widgets/project/project-actions-overlay/ProjectActionsOverlayConnector"
import { ProjectAttachmentsOverlayConnector } from "widgets/project/project-attachments-overlay/ProjectAttachmentsOverlayConnector"
import { ProjectGaebOverlayConnector } from "widgets/project/project-gaeb-overlay/ProjectGaebOverlayConnector"
import { ProjectPDFOverlayConnector } from "widgets/project/project-pdf-overlay/ProjectPDFOverlayConnector"
import { ReplaceAttachmentOverlayConnector } from "widgets/project/replace-attachment-overlay/ReplaceAttachmentOverlayConnector"
import { TeamLeaveOverlayConnector } from "widgets/project/team-leave-overlay/TeamLeaveOverlayConnector"
import { CopyRoomOverlay } from "widgets/room/copy-room-overlay/CopyRoomOverlay"
import { DeleteRoomOverlayConnector } from "widgets/room/delete-room-overlay/DeleteRoomOverlayConnector"
import { EditRoomOverlayConnector } from "widgets/room/edit-room-overlay/EditRoomOverlayConnector"
import { NewRoomOverlayConnector } from "widgets/room/new-room-overlay/NewRoomOverlayConnector"
import { RoomActionsOverlay } from "widgets/room/room-actions-overlay/RoomActionsOverlay"
import { ShareProjectOverlayConnector } from "widgets/share-project-overlay/ShareProjectOverlayConnector"
import { SharedProjectActionsOverlayConnector } from "widgets/shared-project-actions-overlay/SharedProjectActionsOverlayConnector"

interface OverlayFactoryProps {
  overlay: Overlay
}

export const OverlayFactory = React.memo(({ overlay }: OverlayFactoryProps) => {
  switch (overlay?.type) {
    case NEW_PROJECT_OVERLAY:
      return <NewProjectOverlayConnector payload={overlay.payload} />
    case PROJECT_ACTIONS_OVERLAY:
      return <ProjectActionsOverlayConnector payload={overlay.payload} />
    case SHARED_PROJECT_ACTIONS_OVERLAY:
      return <SharedProjectActionsOverlayConnector payload={overlay.payload} />
    case PROJECT_GAEB_OVERLAY:
      return <ProjectGaebOverlayConnector payload={overlay.payload} />
    case PROJECT_PDF_OVERLAY:
      return <ProjectPDFOverlayConnector payload={overlay.payload} />
    case MUSTERHEFT_EXPORT_OVERLAY:
      return <MusterheftExportOverlayConnector payload={overlay.payload} />
    case NEW_ROOM_OVERLAY:
      return <NewRoomOverlayConnector payload={overlay.payload} />
    case EDIT_ROOM_OVERLAY:
      return <EditRoomOverlayConnector payload={overlay.payload} />
    case COPY_ROOM_OVERLAY:
      return <CopyRoomOverlay payload={overlay.payload} />
    case ROOM_ACTIONS_OVERLAY:
      return <RoomActionsOverlay payload={overlay.payload} />
    case NEW_FLOOR_OVERLAY:
      return <NewFloorOverlayConnector payload={overlay.payload} />
    case EDIT_FLOOR_OVERLAY:
      return <EditFloorOverlayConnector payload={overlay.payload} />
    case COPY_FLOOR_OVERLAY:
      return (
        <CopyFloorOverlay
          floorID={overlay.payload.floorID}
          projectID={overlay.payload.projectID}
        />
      )
    case DELETE_FLOOR_OVERLAY:
      return <DeleteFloorOverlayConnector payload={overlay.payload} />
    case FLOOR_ACTIONS_OVERLAY:
      return <FloorActionsOverlay payload={overlay.payload} />
    case NEW_PRODUCT_POSITION_OVERLAY:
      return <NewProductPositionOverlayConnector payload={overlay.payload} />
    case EDIT_PRODUCT_POSITION_OVERLAY:
      return <EditProductPositionOverlay payload={overlay.payload} />
    case PRODUCT_POSITION_ACTIONS_OVERLAY:
      return <ProductPositionActionsOverlay payload={overlay.payload} />
    case EDIT_PROJECT_OVERLAY:
      return <EditProjectOverlayConnector payload={overlay.payload} />
    case DELETE_PROJECT_OVERLAY:
      return <DeleteProjectOverlay payload={overlay.payload} />
    case DUPLICATE_PROJECT_OVERLAY:
      return <DuplicateProjectOverlay payload={overlay.payload} />
    case PROJECT_ATTACHMENTS_OVERLAY:
      return <ProjectAttachmentsOverlayConnector payload={overlay.payload} />
    case CONTENT_OVERLAY:
      return <ContentOverlay payload={overlay.payload} />
    case PROFILE_DELETE_REQUEST_CODE_OVERLAY:
      return <ProfileDeleteOverlayConnector />
    case PROFILE_DELETE_CODE_OVERLAY:
      return <ProfileDeleteSubmitCodeOverlayConnector />
    case DELETE_PRODUCT_POSITIONS_OVERLAY:
      return (
        <DeleteProductPositionsOverlayConnector payload={overlay.payload} />
      )
    case DELETE_ROOM_OVERLAY:
      return <DeleteRoomOverlayConnector payload={overlay.payload} />
    case FAVORITE_ACTIONS_OVERLAY:
      return <FavoriteActionsOverlayConnector payload={overlay.payload} />
    case DELETE_FAVORITES_OVERLAY:
      return <DeleteFavoritesOverlayConnector payload={overlay.payload} />
    case COPY_PROJECT_CHILDREN_OVERLAY:
      return <CopyProjectChildrenOverlayConnector payload={overlay.payload} />
    case DELETE_PROJECT_CHILDREN_OVERLAY:
      return <DeleteProjectChildrenOverlay payload={overlay.payload} />
    case FEEDBACK_OVERLAY:
      return <FeedbackOverlayConnector payload={overlay.payload} />
    case FEEDBACK_ACTIONS_OVERLAY:
      return <FeedbackActionsOverlayConnector />
    case SHARE_OVERLAY:
      return <ShareProjectOverlayConnector payload={overlay.payload} />
    case GLOBAL_SEARCH_OVERLAY:
      return <GlobalSearchOverlayConnector />
    case PRODUCT_CONFIGURATION_OVERLAY:
      return <ProductConfigurationOverlayConnector payload={overlay.payload} />
    case PORTFOLIO_PRODUCT_SELECT_OVERLAY:
      return <PortfolioProductSelectOverlay payload={overlay.payload} />
    case PRODUCT_CONFIGURATOR_MODE_SELECT_OVERLAY:
      return (
        <ProductConfiguratorModeSelectOverlayConnector
          payload={overlay.payload}
        />
      )
    case DELETE_ADDON_OVERLAY:
      return <DeleteAddonOverlay payload={overlay.payload} />
    case SELECT_PRODUCT_CONFIGURATION_PRESET_OVERLAY:
      return <SelectProductBaseVariantOverlay payload={overlay.payload} />
    case INSTALLATION_REFERENCE_SELECTION_OVERLAY:
      return (
        <InstallationReferenceSelectionOverlayConnector
          payload={overlay.payload}
        />
      )
    case DEMAND_REQUEST_OVERLAY:
      return <DemandRequestOverlayConnector />
    case LOGOUT_OVERLAY:
      return <LogoutOverlay />
    case LOGIN_OVERLAY:
      return <LoginOverlayConnector />
    case CONFIRMATION_OVERLAY:
      return <DefaultConfirmationOverlay payload={overlay.payload} />
    case PORTAL_NEWS_OVERLAY:
      return <PortalNewsOverlayConnector />

    case ADD_TEAM_MEMBERS_OVERLAY:
      return (
        <CreateProjectTeamMembersOverlayConnector payload={overlay.payload} />
      )

    case MANAGE_PROJECT_TEAM_OVERLAY:
      return <ManageProjectTeamOverlayConnector payload={overlay.payload} />
    case TEAM_LEAVE_OVERLAY:
      return <TeamLeaveOverlayConnector payload={overlay.payload} />
    case PROJECT_TEAM_INVITATION_LIST_OVERLAY:
      return <ProjectTeamInvitationListOverlayConnector />
    case IMAGE_OVERLAY:
      return <ImageOverlay payload={overlay.payload} />
    case PRODUCT_IMAGE_OVERLAY:
      return <ProductImageOverlay payload={overlay.payload} />
    case PROJECT_HISTORY_OVERLAY:
      return <ProjectHistoryOverlayConnector payload={overlay.payload} />
    case DELETE_ATTACHMENT_OVERLAY:
      return <DeleteAttachmentOverlayConnector payload={overlay.payload} />
    case REPLACE_ATTACHMENT_OVERLAY:
      return <ReplaceAttachmentOverlayConnector payload={overlay.payload} />
    default: {
      // A registry key with no case above is a compile error here, not a
      // silently blank overlay.
      overlay satisfies never
      return null
    }
  }
})
